import addMemberModalTemplate from './add-member-modal.html';

class AddMemberModalController {
  modalInstance: any;
  member: any;
  status = {
    opened: false,
  };

  ok() {
    this.modalInstance.close(this.member);
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }

  open() {
    this.status.opened = true;
  }
}

export const AddMemberModalComponent = {
  template: addMemberModalTemplate,
  bindings: {
    modalInstance: '<',
    member: '<',
  },
  controller: AddMemberModalController,
};
